const largeTabletMedia = matchMedia('(max-width: 1366px)');
const mediumTabletMedia = matchMedia('(max-width: 1024px)');
const mouseMedia = matchMedia('(pointer: fine)');

const isMobile = () =>
  (largeTabletMedia.matches && !mouseMedia.matches) || mediumTabletMedia.matches;

export default isMobile;
